import { render, staticRenderFns } from "./FlagCreateEdit.vue?vue&type=template&id=3370183e"
import script from "./FlagCreateEdit.vue?vue&type=script&lang=js"
export * from "./FlagCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./FlagCreateEdit.vue?vue&type=style&index=0&id=3370183e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports